export const ENDPOINTS = {
  home: '/',
  notFound: '/not-found',

  getInTouch: '/get-in-touch',
  aboutUs: '/about-us',
  ourTeam: '/our-team',
  services: '/our-services',
  // missionVision: '/mission-vision',
  // awards: '/awards',
  // ourValue: '/our-value',

  training: '/training',
  recruitment: '/recruitment',
  sustainability: '/sustainability',
  career: '/careers',
  // sampleMenu: '/sample-menu',

  news: '/news-announcement',
  mediaGalery: '/media-galery',
  // investmentPurchasing: '/investment-purchasing',
  achievements: '/achievements',
} as const;

export const getEndpoints = () => ENDPOINTS;
